import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

// Add token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post('/auth/login', { email, password });
export const logout = () => api.post('/auth/logout');
export const changePassword = (data) => api.post('/auth/change-password', data);
export const getMe = () => api.get('/auth/me');

// Users
export const getProfile = () => api.get('/users/profile');
export const updateProfile = (data) => api.put('/users/profile', data);

// Resources
export const getResources = (params) => api.get('/resources', { params });
export const getCategories = () => api.get('/resources/categories');
export const logDownload = (id) => api.post(`/resources/${id}/download`);

// Admin - Users
export const getAdminUsers = () => api.get('/admin/users');
export const createUser = (data) => api.post('/admin/users', data);
export const updateUser = (id, data) => api.put(`/admin/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/admin/users/${id}`);
export const resetUserPassword = (id, data) =>
  api.post(`/admin/users/${id}/reset-password`, data);

// Admin - Bulk Users
export const bulkCreateUsers = (formData) =>
  api.post('/admin/users/bulk', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

// Admin - Resources
export const getAdminResources = () => api.get('/admin/resources');
export const uploadResourceFile = (formData) =>
  api.post('/admin/resources/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
export const createResource = (data) => api.post('/admin/resources', data);
export const updateResource = (id, data) => api.put(`/admin/resources/${id}`, data);
export const deleteResource = (id) => api.delete(`/admin/resources/${id}`);

// Admin - Categories
export const getAdminCategories = () => api.get('/admin/categories');
export const createCategory = (data) => api.post('/admin/categories', data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);

// Admin - Stats
export const getStats = () => api.get('/admin/stats');

export default api;